import {
  MODAL_OPEN, MODAL_CLOSE, MODAL_INIT, SUBMODAL_OPEN, SUBMODAL_CLOSE, INIT_MODAL_CALLBACK, CLEAR_MODAL_CALLBACK,
  MODAL_PICK_OPEN, MODAL_PICK_OPEN_WITH_ACTION, MODAL_PICK_SAVE, MODAL_PICK_CLOSE,
  MODAL_CONFIRM_OPEN, MODAL_CONFIRM_CLOSE, MODAL_SAVE, GET_CURRENT_TIME, DO_GET_DATE,
  MODAL_LOADING_OPEN, MODAL_LOADING_CLOSE, MODAL_ALERT_OPEN, MODAL_ALERT_CLOSE, SEND_NOTIFY_MSG,
  MODAL_TIP_OPEN, MODAL_TIP_CLOSE, UPLOAD_FILE_INIT, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL,
} from '../actions/index';

const commonProcess = (state, action) => {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        ...state,
        modalStatus: action.commonParams.modalStatus,
        modalMessage: action.commonParams.modalMessage,
        modalRedirect: action.commonParams.modalRedirect,
        callback: action.commonParams.callback,
        status: action.type
      }
    case MODAL_CLOSE:
      return {
        ...state,
        modalStatus: null,
        modalMessage: null,
        modalRedirect: action.commonParams.modalRedirect,
        callback: null,
        status: action.type
      }
    case MODAL_INIT:
      return {
        ...state,
        modalStatus: null,
        modalMessage: null,
        modalRedirect: null,
        status: action.type
      }
    case SUBMODAL_OPEN:
      return {
        ...state,
        subModal: action.params.subModal,
        status: action.type
      }
    case SUBMODAL_CLOSE:
      return {
        ...state,
        subModal: action.params.subModal,
        status: action.type
      }
    case INIT_MODAL_CALLBACK:
      return {
        ...state,
        callback: action.commonParams.callback,
        status: action.type
      }
    case CLEAR_MODAL_CALLBACK:
      return {
        ...state,
        callback: null,
        status: action.type
      }
    case MODAL_CONFIRM_OPEN:
      return {
        ...state,
        isConfirmShow: true,
        confirmTitle: action.commonParams.confirmTitle,
        confirmIcon: action.commonParams.confirmIcon,
        confirmText: action.commonParams.confirmText,
        confirmHeight: action.commonParams.confirmHeight,
        confirmCallback: action.commonParams.confirmCallback,
        cancelCallback: action.commonParams.cancelCallback,
        doubleConfirm: action.commonParams.doubleConfirm,
        status: action.type
      }
    case MODAL_CONFIRM_CLOSE:
      return {
        ...state,
        isConfirmShow: false,
        confirmTitle: '',
        confirmIcon: null,
        confirmText: '',
        confirmHeight: null,
        confirmCallback: null,
        cancelCallback: null,
        doubleConfirm: false,
        status: action.type
      }
    case MODAL_SAVE:
      return {
        ...state,
        disableButton: action.commonParams.disableButton,
        saveConfirm: action.commonParams.confirm,
        saveData: action.commonParams.data,
        status: action.type
      }
    case MODAL_PICK_OPEN:
      return {
        ...state,
        modalPick: action.params.modalPick,
        status: action.type
      }
    case MODAL_PICK_OPEN_WITH_ACTION:
      return {
        ...state,
        modalPick: action.params.modalPick,
        status: action.type
      }
    case MODAL_PICK_SAVE:
      return {
        ...state,
        modalPick: action.params.modalPick,
        status: action.type
      }
    case MODAL_PICK_CLOSE:
      return {
        ...state,
        modalPick: action.params.modalPick,
        status: action.type
      }
    case GET_CURRENT_TIME:
      return {
        ...state,
        currentTime: action.params.currentTime,
        status: action.type
      }
    case DO_GET_DATE:
      return {
        ...state,
        status: DO_GET_DATE,
        dateStatus: action.params.dateStatus,
        filterStartTime: action.params.filterStartTime,
        filterEndTime: action.params.filterEndTime,
        now: action.params.now,
      };
    case MODAL_LOADING_OPEN:
      return {
        ...state,
        status: MODAL_LOADING_OPEN,
        isLoadingShow: true,
        loadingText: action.params.loadingText,
        loadingTitle: action.params.loadingTitle,
      }
    case MODAL_LOADING_CLOSE:
      return {
        ...state,
        status: MODAL_LOADING_CLOSE,
        isLoadingShow: false,
        loadingText: action.params.loadingText,
      }
    case MODAL_ALERT_OPEN:
      return {
        ...state,
        status: MODAL_ALERT_OPEN,
        isAlertShow: true,
        alertText: action.params.alertText,
        alertTitle: action.params.alertTitle,
        callback: action.params.callback,
      }
    case MODAL_ALERT_CLOSE:
      return {
        ...state,
        status: MODAL_ALERT_CLOSE,
        isAlertShow: false,
        alertText: action.params.alertText,
      }
    case SEND_NOTIFY_MSG:
      return {
        ...state,
        status: SEND_NOTIFY_MSG,
        notifyMsg: action.params.notifyMsg
      }
    case MODAL_TIP_OPEN:
      return {
        ...state,
        status: MODAL_TIP_OPEN,
        isTipShow: true,
        tipText: action.params.tipText,
        refTitle: action.params.refTitle,
        callback: action.params.callback,
      }
    case MODAL_TIP_CLOSE:
      return {
        ...state,
        status: MODAL_TIP_CLOSE,
        isTipShow: false,
        tipText: action.params.tipText,
      }
    case UPLOAD_FILE_INIT:
      return {
        ...state,
        status: UPLOAD_FILE_INIT,
        uploadInfo: null,
        errMsg: null
      }
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        status: UPLOAD_FILE_SUCCESS,
        uploadInfo: action.params.uploadInfo,
        errMsg: action.params.errMsg
      }
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        status: UPLOAD_FILE_FAIL,
        uploadInfo: action.params.uploadInfo,
        errMsg: action.params.errMsg
      }
    default:
      return state;
  }
}

const commonReducers = (state = {
  modalStatus: null,
  modalMessage: null,
  modalRedirect: null,
  callback: null,
  modalPick: {
    modalStatus: null,
    modalMessage: null,
    modalResult: null
  },
  isConfirmShow: false,
  confirmText: '',
  confirmCallback: null,
  cancelCallback: null,
  disableButton: 'disabled',
  saveConfirm: false,
  saveData: null,
  currentTime: {
    startTime: null,
    endTime: null,
    timeType: null
  },
  uploadInfo: null,
  status: null

}, action) => {
  switch (action.type) {
    default:
      return commonProcess(state, action);
  }
}

export default commonReducers;